/**
 * ドロワーメニュー制御（フォーカストラップ ＆ アコーディオン対応）
 */
export default function initDrawer() {
  const header = document.querySelector(".l-header");
  const toggleButton = document.getElementById("js-drawer-toggle");
  const drawer = document.getElementById("js-drawer-content");

  if (!header || !toggleButton || !drawer) return;

  const focusableSelector =
    'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"]), [role="button"]';

  const toggleDrawer = (forceOpen) => {
    const isExpanded = toggleButton.getAttribute("aria-expanded") === "true";
    const nextState = typeof forceOpen === "boolean" ? forceOpen : !isExpanded;

    header.classList.toggle("is-drawer-open", nextState);
    toggleButton.setAttribute("aria-expanded", String(nextState));
    drawer.setAttribute("aria-hidden", String(!nextState));
    document.body.style.overflow = nextState ? "hidden" : "";

    if (nextState) {
      setTimeout(() => {
        const firstFocusable = drawer.querySelector(focusableSelector);
        if (firstFocusable) firstFocusable.focus();
      }, 100);
      document.addEventListener("keydown", handleKeydown);
    } else {
      document.removeEventListener("keydown", handleKeydown);
      toggleButton.focus();
    }
  };

  const handleKeydown = (e) => {
    if (e.key === "Escape") {
      toggleDrawer(false);
      return;
    }

    if (e.key !== "Tab") return;

    const focusableEls = Array.from(
      drawer.querySelectorAll(focusableSelector),
    ).filter((el) => el.offsetParent !== null);

    if (focusableEls.length === 0) return;

    const firstEl = focusableEls[0];
    const lastEl = focusableEls[focusableEls.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === firstEl) {
        e.preventDefault();
        lastEl.focus();
      }
    } else if (document.activeElement === lastEl) {
      e.preventDefault();
      firstEl.focus();
    }
  };

  const initAccordion = () => {
    const parents = drawer.querySelectorAll(".has-child");

    parents.forEach((parent) => {
      const trigger = parent.querySelector(".l-drawer-nav__link");
      const content = parent.querySelector(".l-drawer-nav-child");

      if (!trigger || !content) return;

      trigger.setAttribute("role", "button");
      trigger.setAttribute("aria-expanded", "false");
      trigger.setAttribute("tabindex", "0");
      if (!trigger.getAttribute("href")) trigger.removeAttribute("href");

      content.setAttribute("aria-hidden", "true");

      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        toggleAccordion(trigger, content);
      });

      trigger.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          toggleAccordion(trigger, content);
        }
      });
    });
  };

  const toggleAccordion = (trigger, content) => {
    const isExpanded = trigger.getAttribute("aria-expanded") === "true";
    trigger.setAttribute("aria-expanded", String(!isExpanded));
    content.setAttribute("aria-hidden", String(isExpanded));
    trigger.classList.toggle("is-active", !isExpanded);
    content.classList.toggle("is-open", !isExpanded);
  };

  const initDrawerLang = () => {
    const langRoot = drawer.querySelector(".js-drawer-lang");
    const trigger = langRoot?.querySelector(".l-drawer-lang__trigger");
    const list = document.getElementById("js-drawer-lang-list");

    if (!langRoot || !trigger || !list) return;

    let isOpen = false;

    const setOpen = (open) => {
      isOpen = open;
      langRoot.classList.toggle("is-open", open);
      trigger.setAttribute("aria-expanded", String(open));
      list.hidden = !open;
    };

    trigger.addEventListener("click", () => {
      setOpen(!isOpen);
    });

    document.addEventListener("click", (event) => {
      if (!isOpen) return;
      if (!langRoot.contains(event.target)) {
        setOpen(false);
      }
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && isOpen) {
        setOpen(false);
        trigger.focus();
      }
    });
  };

  toggleButton.addEventListener("click", (e) => {
    e.preventDefault();
    toggleDrawer();
  });

  document.querySelectorAll(".js-drawer-close").forEach((el) => {
    el.addEventListener("click", () => toggleDrawer(false));
  });

  drawer.querySelectorAll("a").forEach((link) => {
    link.addEventListener("click", () => toggleDrawer(false));
  });

  initAccordion();
  initDrawerLang();
}
